import { EventEmitter, Injectable, inject } from '@angular/core';
import {HydraService} from '../../../core/services/hydra.service';
import {LocalisationSc} from '../../../class/api/LocalisationSc';
import {api} from '../../../api/api-dictionnary';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {ExLocalisationInfo} from '../../../class/ex/ex-localisation-info';
import {LocalisationInfoItem, LocalisationInfoItemInterface} from '../../../class/api/LocalisationInfoItem';
import {LocalisationInfo} from '../../../class/api/LocalisationInfo';
import {LocalisationMetastaseInterface} from '../../../class/api/LocalisationMetastase';
import {Subscription} from 'rxjs';

@Injectable()
export class LocalisationService {
    private hydraService = inject(HydraService);

    public localisations: LocalisationSc[] = [];
    public metastases: LocalisationMetastaseInterface[] = [];
    private _localisationInfo: ExLocalisationInfo = null;

    public observer: EventEmitter<ExLocalisationInfo> = new EventEmitter();

    public localisationSubscription: Subscription = null;

    get localisationInfo(): ExLocalisationInfo {
        return this._localisationInfo;
    }

    set localisationInfo(value: ExLocalisationInfo) {
        if (value != null) {
            this._localisationInfo = new ExLocalisationInfo(value);
        } else {
            this._localisationInfo = new ExLocalisationInfo();
        }
    }

    public autoUpdate = true;

    constructor() {
        //Quand le service est instancié on charge les localisations;
    }

    public getLocalisation() {
        this.hydraService
            .getList(api.localisations + '?enabled=true')
            .subscribe((item: HydraCollection) => {
                this.localisations = item.getMember() as LocalisationSc[];
            });
        this.hydraService
            .getList(api.metastases)
            .subscribe((item: HydraCollection) => {
                this.metastases = item.getMember() as LocalisationMetastaseInterface[];
            });
    }

    public addCancer() {
        this.localisationInfo.cancerPrimitifs.push(new LocalisationInfoItem());
        if (this.autoUpdate) {
            this.save();
        }
    }

    public removeCancer(index) {
        this.localisationInfo.cancerPrimitifs.splice(index, 1);
        if (this.autoUpdate) {
            this.save();
        }
    }

    public setCancer(cancer: LocalisationInfoItemInterface, cancerIndex: number) {
        if (
            this.localisationInfo.cancerPrimitifs[cancerIndex]['id'] != null &&
            this.localisationInfo.cancerPrimitifs[cancerIndex]['id'] != undefined
        ) {
            cancer['id'] = this.localisationInfo.cancerPrimitifs[cancerIndex]['id'];
        }

        if (
            this.localisationInfo.cancerPrimitifs[cancerIndex]['@id'] != null &&
            this.localisationInfo.cancerPrimitifs[cancerIndex]['@id'] != undefined
        ) {
            cancer['@id'] = this.localisationInfo.cancerPrimitifs[cancerIndex]['@id'];
        }

        this.localisationInfo.cancerPrimitifs[cancerIndex] = cancer;

        if (this.autoUpdate) {
            this.save();
        }
    }

    public save() {
        if(this.localisationSubscription){
            this.localisationSubscription.unsubscribe();
            this.localisationSubscription = null;
        }
        if(this.localisationInfoIsValid()){
            this.localisationInfo.typeLocalisations = +this.localisationInfo.typeLocalisations;

            const beforeSave = {...this.localisationInfo};
            let url = '';
            if (beforeSave['id'] !== null && beforeSave['id'] !== undefined) {
                url = api.localisationInfos + '/' + this.localisationInfo['id'];
            } else {
                url = api.localisationInfos;
            }

            this.localisationSubscription = this.hydraService.save(url + '?noLoader', beforeSave).subscribe(res => {
                this.localisationInfo['id'] = res['id'];
                this.localisationInfo['@id'] = res['@id'];

                const cancerPrimitifs = [];
                for(const localisationInfoItem of res['cancerPrimitifs']){
                    cancerPrimitifs.push( {...localisationInfoItem} );
                }
                this.localisationInfo.cancerPrimitifs = cancerPrimitifs;
                this.observer.emit(new LocalisationInfo(res));
                this.localisationSubscription.unsubscribe();
            });
        }

    }

    public localisationInfoIsValid(): boolean {
        // On test les cancers primitifs pour voir si on attend des précisions.
        if (+this.localisationInfo.typeLocalisations != 2) {
            return true;
        }

        if (this.localisationInfo.cancerPrimitifs.length == 0) {
            return false;
        }

        for (const item of this.localisationInfo.cancerPrimitifs) {
            const localisation = item.localisation as LocalisationSc;
            if (localisation == null) {
                return false;
            }

            if (
                localisation.champSaisieLibre === true &&
                (item.precisionLocalisation == null || item.precisionLocalisation == '')
            ) {
                return false;
            }
        }

        return true;
    }
}
